import React from "react";
import "../incomeAnalyzer.scss";
const NoItem = () => {
	return (
		<>
			<div className="no-item-blc text-center right-col d-flex align-items-center justify-content-center">
				{'No Record Found'}
			</div>
		</>
	);
}

export default NoItem;